import PageHero from "@/components/PageHero";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";

export default function Endorsements() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/endorsements").then((r) => setList(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="endorsements-page">
      <PageHero
        eyebrow="Voices of Support"
        title="Endorsed by colleagues, mentors, and the medical fraternity."
        subtitle="Their words. Our shared commitment."
      />
      <section className="section-y">
        <div className="container-x">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((e) => (
              <div key={e.id} className="card-flat" data-testid={`endorsement-card-${e.id}`}>
                <Quote className="text-[hsl(var(--accent))]" size={28} />
                <p className="mt-4 leading-relaxed">"{e.message}"</p>
                <div className="mt-6 pt-4 border-t border-[hsl(var(--border-c))] flex items-center gap-3">
                  {e.image_url && (
                    <img src={e.image_url} alt={e.name} className="w-10 h-10 object-cover" loading="lazy" />
                  )}
                  <div>
                    <div className="font-display text-lg text-[hsl(var(--primary))]">{e.name}</div>
                    {e.designation && <div className="text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--fg-muted))]">{e.designation}</div>}
                  </div>
                </div>
              </div>
            ))}
            {list.length === 0 && <div className="text-[hsl(var(--fg-muted))]">No endorsements yet.</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
